<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="cloud-assets-sections">
	<form [formGroup]="configurationForm">
		<div class="filters">
			<globalictcc-dropdown
				label="Cloud Provider"
				formControlName="cloudProviders"
				[multi]="true"
				[options]="cloudProvidersOptions"
			/>
			<globalictcc-dropdown
				label="Location"
				formControlName="locations"
				[multi]="true"
				[options]="locationOptions"
			/>

			<globalictcc-dropdown
				label="Application"
				formControlName="applications"
				[multi]="true"
				[options]="applicationOptions"
			/>

			<globalictcc-datepicker
				label="Time period"
				formControlName="timePeriod"
			/>

			<globalictcc-button
				label="Apply"
				[disabled]="configurationForm.invalid"
				(handleClick)="onApply()"
			/>
		</div>
	</form>

	@if (authorizationService.canSee(grants.totalCo2Emissions)) {
		@let totalCO2 = (totalCO2$ | async)?.data;
		<globalictcc-kpi
			label="Total CO2e Emissions"
			[value]="totalCO2?.value"
			[unit]="totalCO2?.unit"
		/>
	}

	@let canSeePerformance = authorizationService.canSee(grants.myCloudProviders);
	@let canSeeEmissions = authorizationService.canSee(grants.cloudProvidersEmissions);
	@if (canSeePerformance || canSeeEmissions) {
		<section class="cloud-dashboard-section">
			@if (canSeePerformance) {
				@let cloudPerformanceChart = cloudPerformanceChart$ | async;
				<div class="dashboard-chart-container">
					<div class="chart-actions">
						<globalictcc-button
							label="Export performance chart"
							[textOnly]="true"
							iconName="download"
							(handleClick)="
								onExportChart(
									cloudPerformanceChartRef.instance,
									'cloud_performance'
								)
							"
						/>
					</div>

					<globalictcc-chart
						#cloudPerformanceChartRef
						chartType="line"
						[data]="cloudPerformanceChart?.data?.chart"
						[isLoading]="cloudPerformanceChart?.isLoading ?? true"
						[hasError]="
							cloudPerformanceChart?.hasError || cloudPerformanceChart?.data?.hasError
						"
						[isLegendVisible]="true"
						[configOverrides]="cloudPerformanceChartOverrides"
					/>
				</div>
			}

			@if (canSeeEmissions) {
				@let totalEmissionPieChart = totalEmissionPieChart$ | async;
				<div class="dashboard-chart-container">
					<div class="chart-actions">
						<globalictcc-button
							label="Export emissions chart"
							[textOnly]="true"
							iconName="download"
							(handleClick)="
								onExportChart(totalEmissionChart.instance, 'cloud_total_emissions')
							"
						/>
					</div>

					<globalictcc-chart
						#totalEmissionChart
						chartType="pie"
						labelPosition="outside"
						[data]="totalEmissionPieChart?.data?.chart"
						[hasError]="
							totalEmissionPieChart?.hasError || totalEmissionPieChart?.data?.hasError
						"
						[isLoading]="totalEmissionPieChart?.isLoading ?? true"
						[colors]="totalEmissionPieChartColors"
					/>
				</div>
			}
		</section>
	}

	<div class="chips">
		<globalictcc-chips
			[chips]="chips"
			(handleSelection)="handleSelection($event)"
		/>
	</div>

	<div>
		<router-outlet />
	</div>

	<div class="bottom-actions">
		<globalictcc-button
			label="Export report"
			iconName="document"
			[textOnly]="true"
			(handleClick)="onExportInsightsReport()"
		/>
		<globalictcc-button
			label="Download as CSV"
			iconName="download"
			[textOnly]="true"
			(handleClick)="onDownloadAsCSV()"
		/>
	</div>

	<div class="external-dashboard">
		<a
			href="https://app.powerbi.com/groups/me/reports/6df4d1aa-4fb5-4c05-b692-75824882c462/b00c2636b9de6a080a2d?ctid=3048dc87-43f0-4100-9acb-ae1971c79395&openReportSource=ReportInvitation&experience=power-bi"
			target="_blank"
			rel="noopener noreferrer"
		>
			<globalictcc-button label="Open Microsoft365 Dashboard" />
		</a>
	</div>
</section>
